import { Outlet } from "react-router-dom";
import Header from "./header";
import Sidebar from "./sidebar";
import styles from "./dashboardLayout.module.scss";
import { Drawer } from "antd";
import { useState } from "react";
import { useAtomValue } from "jotai";
import { userAtom } from "../../utils/store";
import { useQuery } from "@tanstack/react-query";
import { getPersonalInfoByApplicantId } from "../../utils/request";

const DashboardLayout = () => {
  const [openSidebar, setOpenSidebar] = useState(false);
  const user = useAtomValue(userAtom);

  const handleOpen = () => setOpenSidebar(true);
  const handleClose = () => setOpenSidebar(false);

  const { data, isLoading } = useQuery({
    queryKey: ["get-personal-info-id"],
    queryFn: () => getPersonalInfoByApplicantId(user?.applicantId ?? ""),
  });

  return (
    <main className={styles.container}>
      <section className={styles.sidebar}>
        <Sidebar />
      </section>

      <Drawer
        placement={"left"}
        onClose={handleClose}
        open={openSidebar}
        width={"70%"}
        style={{
          fontFamily: "BRFirma-Medium, sans-serif",
          background: "#2B0C12",
        }}
      >
        <Sidebar />
      </Drawer>

      <section className={styles.mainContent}>
        <Header
          handleOpenSidebar={handleOpen}
          image={data?.data?.imageUrl ?? ""}
          isLoading={isLoading}
        />

        <div className={styles.children}>
          <Outlet />
        </div>
      </section>
    </main>
  );
};

export default DashboardLayout;
